/// <reference path="../types/index.d.ts" />

import '../client_forms/blackwoodscatering/style.css';
import FormStructure from './blackwoodscatering/form_structure';

export default FormStructure;